import React from 'react';
import { useLanguage } from '../hooks/useLanguage';

export default function AuthAvailabilityNotice() {
  const { t } = useLanguage();

  return (
    <p
      className="form-message"
      role="status"
      style={{
        background: 'var(--surface-muted)',
        color: 'var(--ink)',
        borderLeftColor: 'var(--accent)',
        lineHeight: 1.55,
      }}
    >
      {t('auth.unavailable')}
    </p>
  );
}
